export const SET_SESSION_MODAL = 'SET_SESSION_MODAL';
export const SET_UNAUTHORIZED_MODAL = 'SET_UNAUTHORIZED_MODAL';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SIGN_OUT = 'SIGN_OUT';
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';
export const SET_SUCCESS_NOTIFICATION = 'SET_SUCCESS_NOTIFICATION';
export const SET_ERROR_NOTIFICATION = 'SET_ERROR_NOTIFICATION';
export const SET_WARNING_NOTIFICATION = 'SET_WARNING_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const CLEAR_APPLICATIONS_MODULE = 'CLEAR_APPLICATIONS_MODULE';

export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_SITE_DESIGNATION = 'SET_SITE_DESIGNATION';
export const SET_ALL_COMPANIES = 'SET_ALL_COMPANIES';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_PROFILE_COMPANY = 'SET_PROFILE_COMPANY';
export const UPDATE_PROFILE_COMPANY_LOADING = 'UPDATE_PROFILE_COMPANY_LOADING';
export const REMOVE_LOAD_TEMPLATE = 'REMOVE_LOAD_TEMPLATE';
export const CLEAR_COMPANIES_MODULE = 'CLEAR_COMPANIES_MODULE';

export const SET_MAP_RESULTS = 'SET_MAP_RESULTS';
export const CLEAR_MAPS_MODULE = 'CLEAR_MAPS_MODULE';
export const SET_USER_POSITION = 'SET_USER_POSITION';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const CLEAR_PROFILES_MODULE = 'CLEAR_PROFILES_MODULE';
export const SET_USER_INFO = 'SET_USER_INFO';

export const SET_LIGHTBOX_ASSET = 'SET_LIGHTBOX_ASSET';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

export const SET_REFERRER_INFO = 'SET_REFERRER_INFO';

export const SET_QB_CUSTOMERS = 'SET_QB_CUSTOMERS';
export const SET_QB_ACCOUNTS = 'SET_QB_ACCOUNTS';
export const SET_QB_VENDORS = 'SET_QB_VENDORS';
export const SET_QB_TERMS = 'SET_QB_TERMS';
export const SET_QB_SALES_ITEMS = 'SET_QB_SALES_ITEMS';
export const SET_QB_TAX_CODES = 'SET_QB_TAX_CODES';
export const CLEAR_QB_MODULE = 'CLEAR_QB_MODULE';

export const SET_XRO_CONTACTS = 'SET_XRO_CONTACTS';
export const SET_XRO_ACCOUNTS = 'SET_XRO_ACCOUNTS';
export const SET_XRO_SALES_ITEMS = 'SET_XRO_SALES_ITEMS';
export const CLEAR_XRO_MODULE = 'CLEAR_XRO_MODULE';

export const CLEAR_QB_COMPANY_MODULE = 'CLEAR_QB_COMPANY_MODULE';
export const SET_BOOKED_LOADS = 'SET_BOOKED_LOADS';
export const UPDATE_LOAD = 'UPDATE_LOAD';
export const REMOVE_LOAD = 'REMOVE_LOAD';
export const UPDATE_LOAD_TACTICAL_INFO = 'UPDATE_LOAD_TACTICAL_INFO';

export const SET_PLANNED_LOADS = 'SET_PLANNED_LOADS';
export const UPDATE_PLANNED_LOAD = 'UPDATE_PLANNED_LOAD';
export const SET_REPEATING_LOAD_TEMPLATES = 'SET_REPEATING_LOAD_TEMPLATES';
export const UPDATE_REPEATING_LOAD_TEMPLATE = 'UPDATE_REPEATING_LOAD_TEMPLATE';

export const SET_DISPATCH_REQUESTS = 'SET_DISPATCH_REQUESTS';
export const UPDATE_DISPATCH_REQUEST = 'UPDATE_DISPATCH_REQUEST';

export const SET_LOAD_TRANSACTIONS = 'SET_LOAD_TRANSACTIONS';
export const UPDATE_LOAD_TRANSACTION = 'UPDATE_LOAD_TRANSACTION';
export const REMOVE_LOAD_TRANSACTION = 'REMOVE_LOAD_TRANSACTION';

export const UPDATE_COMPANIES_LOADING = 'UPDATE_COMPANIES_LOADING';

export const SET_BIDS = 'SET_BIDS';

export const UPDATE_DAYS_INTO_FUTURE = 'UPDATE_DAYS_INTO_FUTURE';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js